import { DocumentReference} from '@angular/fire/compat/firestore';

export class JoinKeys {
    id: string;
    catalog: DocumentReference;
    name: string;
    tagline : string;

}
